import React, { Component } from 'react'
import Menu from './Menu';
import Mobile_menu from './Mobile_menu';
import Logo from './Logo'
import Header_search from './Header_search'


    export class Header2 extends Component {
    
        componentDidMount() {
            window.addEventListener('scroll', this.isSticky);
        }
    
        componentWillUnmount() {
            window.removeEventListener('scroll', this.isSticky);
        }
    
        isSticky = (e)=>{
            const header = document.querySelector('header');
            const scrollTop = window.scrollY;
            scrollTop >= 250 ? header.classList.add('is-Sticky') : header.classList.remove('is-Sticky');
        };
    
    render() {
        return (
            <header id="masthead" className="header ttm-header-style-03">
                {/* ttm-topbar-wrapper */}
                <div className="ttm-topbar-wrapper bg-theme-DarkColor clearfix">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5">
                                <ul className="top-contact text-left">
                                    <li><i className="fa fa-map-marker"/>85 Road Broklyn Street, 600New York, USA</li>
                                    <li><i className="ti-time"/>&nbsp;&nbsp;Opening Hours:6 to 5</li>
                                </ul>
                            </div>
                            <div className="col-lg-7">
                                <div className="topbar-right text-right d-flex justify-content-end">
                                    <div className="ttm-social-links-wrapper list-inline">
                                        <ul className="social-icons">
                                            <li className="ttm-social-facebook"><a href="https://www.facebook.com/preyantechnosys19" rel="noopener" aria-label="facebook"><i class="icon-facebook"></i>facebook</a>
                                            </li>
                                            <li className="ttm-social-twitter"><a href="https://twitter.com/PreyanTechnosys" rel="noopener" aria-label="twitter"><i class="icon-twitter"></i>twitter</a>
                                            </li>
                                            <li className="ttm-social-instagram"><a href="https://www.instagram.com/preyan_technosys/" rel="noopener" aria-label="instagram"><i class="icon-instagram"></i>instagram</a>
                                            </li>
                                            <li className="ttm-social-linkedin"><a href="https://www.linkedin.com/in/preyan-technosys-pvt-ltd/" rel="noopener" aria-label="linkedin"><i class="icon-linkedin"></i>linkedin</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ttm-topbar-wrapper end */}
                {/* site-header-menu */}
                <div id="site-header-menu" className="site-header-menu bg-theme-WhiteColor">
                    <div className="site-header-menu-inner ttm-stickable-header">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    {/* site-navigation */}
                                    <div className="site-navigation d-flex flex-row align-items-center justify-content-between">
                                        {/* site-branding */}
                                        <div className="site-branding">
                                            <a className="home-link" href={process.env.PUBLIC_URL + '/'} title="Cleano" rel="home">
                                                <img width="185" height="50" id="logo-img" className="img-fluid" alt="logo" src="images/logo-img-white.svg" />
                                            </a>
                                        </div>
                                        {/* site-branding end */}
                                        <div className="border-box-block">
                                            <div className=" d-flex align-items-center">
                                                {/* menu */}
                                                <Menu/>
                                                <div className="mobile-menu"><Mobile_menu/></div>
                                                {/* menu end */}
                                                <div className="ttm-widget_header d-flex flex-row">
                                                    <div className="widget_info d-flex flex-row align-items-center justify-content-end">
                                                    </div>
                                                    <div className="header_btn">
                                                        <a href={process.env.PUBLIC_URL + '/Services'} className="ttm-btn ttm-btn-style-border text-theme-WhiteColor ml-30"> Order service now </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>{/* site-navigation end */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* site-header-menu end */}
            </header> 
        
        )
    }
}

export default Header2;